
import { mapState, mapActions, mapGetters } from 'vuex'
import dayjs from 'dayjs'
import api from '~/api/' // server
import List from '~/components/Common/NewsFlashView/FlashList'
import ResearchPaging from '~/components/Research/ResearchPaging'

export default {
    name: 'NewsFlashIndex',

    components: {
        List,
        ResearchPaging,
    },

    props: {
        newsType: String,
        menuType: {
            type: String,
            default: null,
        },
        pageTitle: String,
        date: {
            type: Boolean,
            default: false,
        },
        onlyperiod: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            curPage: 1, // 현재페이지
            countByPage: 15, // 한페이지당 갯수

            componentKey: 0,
            slotData: [],
            // 변경 중인 ..
            list: [],
            totalCount : 0,
            checkFirst: false,
            loadingStatus: true,
            query:{},
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch']),
        ...mapState ({
            MEMBER_INFO : state => state.member.memberInfo,
        }),
        
        // 전체 글의 수
        setTotalCount() {
            let count = 0
            if (this.list != null && this.list.length > 0) {
                count = this.totalCount
            }
            return count
        },
    },
    watch: {
        getSearch() {
            this.curPage=1
            this.getList()
        },
    },
    created() {
        // this.getList()
        /* 220610 meej 메인페이지에서 속보제목 클릭해서 들어올경우 */
        this.query = this.$route.query
    },
    methods: {
        ...mapActions('board', ['GET_CONTENT']),
        ...mapActions('modal', ['SHOW_ALERT', 'HIDE_MODAL']),

        async getList() {
            this.loadingStatus = true
            const params = {
                countByPage: this.countByPage,
                pageNo : this.curPage,
                ...this.getSearch,
            }
    
            try {
                await api.getTickerListSearch(params).then((response) =>{
                    this.loadingStatus = false
                    const res = response.data
                    this.totalCount = res.totalCount

                    // console.log('res.items : ' + JSON.stringify(res.items.length));
                    
                    if (res.items.length > 0) {
                        this.list = res.items            
                        this.setContent(this.list[0])
                        // console.log('[check params] params.startDate: ', params.startDate, ', params.endDate: ', params.endDate);  
                    } else {
                        this.list = []
                    }
                })
            } catch (error) {
                this.list = []
                // console.log('blog_error=', error)
            }
        },

        onClickItem(values) {
            this.setContent(values)
        },

        ContentData(data) {
            this.slotData = data
        },
        // 하위 컴포넌트 렌더링 문제
        forceRerender() {
            this.componentKey += 1
        },

        // 22.11.04 suye 수정 
        // 22.04.15 suye 기간제한일자 반환 함수: 오늘일자 - num => 기준일자 
        limitDateMaker(num){
            // 현재일자  
            const today = new Date();
            const year = today.getFullYear();
            const month = ('0' + (today.getMonth() + 1)).slice(-2);
            const day = ('0' + today.getDate()).slice(-2);

            // 현재일자 기준 -n일
            const dateLimit = new Date(year, Number(month)-1, day) 

            dateLimit.setDate(dateLimit.getDate() - num)

            // let limited = dateLimit.toLocaleDateString().replace(/\./g, '').replace(/(\s*)/g, "") // 일자 yyyyMMdd
            let limited = dateLimit.toLocaleDateString()
            // console.log('limited', limited)
            const changed = []
            const final = []
            if(limited.includes('.')){
                const splited = limited.split('.')
                if(splited.indexOf('') !== -1) splited.splice(splited.indexOf(''))
                // console.log('splited', splited)
                splited.forEach(e => {
                    changed.push(e.trim())
                });
            }
            if(changed && changed.length > 0){
                changed.forEach(e => {
                    if(e.length === 1){
                        e = '0'+e
                    }
                    final.push(e)
                });
            // console.log('final', final)
            }
            limited = final.join('')
            console.log('limited', limited)

            return limited
        },

        async setContent(values) {
            // targetIndex = 현재 선택되어있는 페이지
            // values.index = 현재 선택된 아이템 번호
            // console.log('setContent')
            // console.log(values)
            let firstContent = {}
            let content = []
            if (this.list.length) {
                /* 
                    220610 meej 메인페이지에서 속보제목 클릭해서 들어올경우 
                 */
                if(this.query != null && this.query.id !== null){
                    // 유료회원 아닐때 
                    if(this.MEMBER_INFO === null 
                        || (this.MEMBER_INFO !== null && this.MEMBER_INFO.type !== 'REGULAR' 
                        && this.MEMBER_INFO.type !== 'CORPORATE')){
                        const today = dayjs(new Date()).format('YYYYMMDD');
                        if(today === this.query.sendDate){
                            this.query = null
                            return 
                        }  
                    }
                    // 유료회원 이면 content 보여줌
                    const findContent = this.list.find((el)=>{
                        if(el.id === this.query.id) return true
                    })
                    firstContent = findContent
                    this.query = null
                }else{

                    if (values) {
                        firstContent = values
                    } else {
                        // 클릭되지 않고 처음 들어오는 페이지 일경우 첫번째 아이템을 보여준다
                        firstContent = values
                        // firstContent = this.list[this.curPage][0]
                    } 
                    
                    // 속보자료 첫화면에 띄워지는 컨텐츠 제어문
                    if(this.checkFirst === false) {
                        this.checkFirst = true
                        firstContent = this.list[0]

                        // 22.04.15 suye 권한별 일자 제한: 첫게시글이 오늘일자와 동일하지 않도록           
                        // 유료회원 아닐때         
                        if(this.MEMBER_INFO === null || (this.MEMBER_INFO !== null && this.MEMBER_INFO.type !== 'REGULAR' && this.MEMBER_INFO.type !== 'CORPORATE')){
                            const today = this.limitDateMaker(0)
                            const contTemp = []
                            this.list.forEach(e => {                                 // 리스트의 sendDate값 <-> 오늘일자 비교 
                                if('sendDate' in e && e.sendDate !== null && e.sendDate !== undefined && e.sendDate !== ''){          // sendDate일 경우 
                                    if(today !== e.sendDate && today - e.sendDate >= 1){    // 오늘일자-1d -> 전일자 (주말동안 비어있는 경우 때문에 === -> >=)
                                        contTemp.push(e)
                                    }
                                } else if('showDate' in e && e.showDate !== null && e.showDate !== undefined && e.showDate !== '') {  // showDate일 경우
                                    if(today !== e.showDate && today - e.showDate >= 1){    
                                        contTemp.push(e)
                                    }
                                }
                            }); 
                            firstContent = contTemp[0] // 전일자의 첫 컨텐츠 현출
                        // 유료회원일때    
                        } else if(this.MEMBER_INFO.type === 'REGULAR' || this.MEMBER_INFO.type === 'CORPORATE'){       
                            firstContent = this.list[0]                                                       
                        }  
                    }
                }

                // 22.05.10 suye firstContent.newsType1 없을 시 오류 제거 
                if(firstContent.newsType1 !== undefined && firstContent.newsType1 !== null && firstContent.newsType1 !== ''){
                    let params = Object
                    let htmlfile = Object
                    params = {
                            id: firstContent.id,
                            newsType: firstContent.newsType1,
                        }
                    // tickerDetail에 flash/html 연결되어있음
                    htmlfile = await api.getTickerDetail(params)
                    firstContent.content = htmlfile.data.content
                    content = firstContent

                    //  디테일 컴포넌트에 넘겨줌
                    this.slotData = content
                }
            }
        },
        /* 20210521 shb paging 관련  */
        onChangePage() {
            this.setContent()
        },
        // 페이지 번호 클릭시
        onClickPage(page) {
            this.curPage = page
            this.getList()
        },
    },
}
